const messages = {
  dashboard: {
    title: "Dashboard",
    description:
      "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
    overview: {
      title: "Overzicht van deelnemende klanten",
      description:
        'Bedrijven die zich bij BRIDGESTONE <span class="text-danger">PLUS</span> hebben geregistreerd en die wij via het klantnummer aan u kunnen toewijzen.',
      month: "Aangemaakt voor BS Plus",
      year: "Geregistreerd in BS Plus",
      all: "Totaal",
    },
    credits: {
      title: "Overzicht Marketingpunten",
      description:
        "Marketingpunten worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
      month: "Huidige maand",
      year: "Totaal huidig jaar gespaard",
      prev_year: "Totaal vorig jaar gespaard",
      allDealers: "Alle dealerpunten",
      allPoints: "Alle punten",
      prev_month: "Vorige maand",
      tenant: {
        de_ch: {
          title: "Puntenoverzicht",
          description:
            "Punten worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
          prev_month: "Vorige maand",
          month: "Huidige maand",
          prev_year: "Vorig jaar",
          allPoints: "Alle punten",
          allDealers: "Alle dealerpunten",
        },
        nl: {
          title: "Overzicht Marketingpunten",
          description:
            "Marketingpunten worden toegekend aan deelnemende bedrijven op basis van de ingediende verkoopcijfers.",
          prev_month: "Vorige maand",
          month: "Huidige maand",
          year: "Totaal huidig jaar gespaard",
          prev_year: "Totaal vorig jaar gespaard",
        },
      },
      yearTyre: "Totaal huidig jaar gekocht",
      prev_yearTyre: "Totaal vorig jaar gekocht",
    },
    details: {
      title: "Deelnemende klanten in detail",
      description:
        'Hieronder vindt u de bedrijven die zich hebben geregistreerd met een Bridgestone klantnummer op BRIDGESTONE <span class="text-danger">PLUS</span> en die aan u zijn toegewezen. Gebruik de sorteerfuncties of de zoekfunctie om specifieker te zoeken.<br/><br/><b>Opmerking: klik op de naam van de klant om naar het gedetaileerde overzicht te gaan</b>',
    },
    lastImport:
      "Een vertraging tot 5 dagen in de verkoopcijfers <span class='text-danger'>{date}</span>",
    kickback: {
      description:
        "Bonus wordt toegekend aan deelnemende bedrijven op basis van ingediende verkoopcijfers.",
    },
    tyres: {
      title: "Banden",
      description: "Banden gekocht door deelnemers aan het programma",
    },
    short:
      "Welkom in uw dashboard. Hier kunt u actuele cijfers en deelnemende bedrijven uit uw klantenbestand bekijken.",
    headers: {
      city: "Stad",
      company: "Bedrijf",
      current_points: "huidige punten",
      customer_number: "klantnummer",
      details: "details",
      last_login: "Laatste login",
      name: "naam",
      postal_code: "Postcode",
      street: "straat",
      email: "E-mail",
    },
    reload: "Vernieuwen",
    exports: {
      title: "Geëxporteerde Excels",
      downloadExcel: "Excel downloaden",
      running: "Bezig",
      head: {
        name: "Naam",
        status: "Status",
      },
    },
  },
};

export default {
  messages,
};
